module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames3-d53d9d670539ddaa84020da61b92bbbc.png";